export default "__VITE_ASSET__DqY8sxYD__"